import TariffsTable from './TariffsTable';

export default TariffsTable;
